import { createRouter, createWebHistory } from 'vue-router';
// step1は初期から表示が必要なのでlazy loadしない
import Step1 from '@component_path/pages/m3c_premium_inquiries/series/haken_tap_form/steps/Step1';
const Step2 = () => import(/* webpackChunkName: "m3c-premium-inquiries-tap-step2" */ '@component_path/pages/m3c_premium_inquiries/series/haken_tap_form/steps/Step2');
const Step3 = () => import(/* webpackChunkName: "m3c-premium-inquiries-tap-step3" */ '@component_path/pages/m3c_premium_inquiries/series/haken_tap_form/steps/Step3');

export default createRouter({
  history: createWebHistory(window.location.pathname.replace(/\/step\d+/, '')),
  mode: 'history',
  routes: [
    {
      path: '/step1',
      name: 'step1',
      component: Step1,
      meta: {
        order: 1,
        subject: '転職希望時期'
      }
    },
    {
      path: '/step2',
      name: 'step2',
      component: Step2,
      meta: {
        order: 2,
        subject: 'お住まいのエリア・生まれ年'
      }
    },
    {
      path: '/step3',
      name: 'step3',
      component: Step3,
      meta: {
        order: 3,
        subject: 'ご連絡先'
      }
    }
  ]
});